// ─────────────────────────────────────────────────────────────────────────────
// Artist CNTRL, React FOUNDATION entry point.
//
// Mounts <App/> into #root on the standalone host page (site/app-react.html).
// This is the bootstrap for the incremental React migration that will replace
// the legacy global/IIFE frontend over time. It runs in complete isolation from
// the legacy app (no window.ac* globals, no /js/*.js), the two coexist.
// ─────────────────────────────────────────────────────────────────────────────

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Artist CNTRL React mount failed: #root not found');
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>
);
